// extracted by mini-css-extract-plugin
export default {"value":"objectUI_value__GgZMy"};